module.exports = __webpack_public_path__ + "img/zenbooka14.a231781a.jpg";